// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PeopleList-empty{color:var(--tru-blue);font-weight:bold}", "",{"version":3,"sources":["webpack://./components/PeopleList/index.sass"],"names":[],"mappings":"AACE,kBACE,qBAAA,CACA,gBAAA","sourcesContent":[".PeopleList\n  &-empty\n    color: var(--tru-blue)\n    font-weight: bold"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
